export default {
      id: "grid-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#grid",
      toString: function () {
        return this.url;
      }
    }